import { FaHospitalUser } from 'react-icons/fa6';

import {
  // IconDashboard,
  IconMap,
  IconUsers,
  IconBriefcase,
  IconClockPaper,
  IconCalendar,
  IconSleep,
  IconPresentation,
  IconIntegration,
  // IconPersonMoney,
  IconSpeaker,
  IconClock,
} from 'assets/icons';
import FEATURES from 'global/features';
import { routePaths } from 'global/routePaths';

const sidebarData = [
  // {
  //   icon: IconDashboard,
  //   label: 'Dashboard',
  //   path: routePaths.dashboard,
  // },
  {
    icon: IconClock,
    label: 'common:employeeTimeClock',
    path: routePaths.employeeTimeClock.route,
    access: routePaths.employeeTimeClock.access,
  },
  {
    icon: IconMap,
    label: 'common:whosWorking',
    path: routePaths.whoIsWorking.route,
    access: routePaths.whoIsWorking.access,
  },
  {
    icon: IconUsers,
    label: 'common:users',
    path: routePaths.employees.base.route,
    access: routePaths.employees.base.access,
  },
  {
    icon: IconBriefcase,
    label: 'common:jobs&Tasks',
    path: routePaths.jobsAndTasks.base.route,
    access: routePaths.jobsAndTasks.base.access,
    featureName: FEATURES.jobs,
  },
  {
    icon: IconSpeaker,
    label: 'common:messageBlast',
    path: routePaths.messageBlast.base.route,
    access: routePaths.messageBlast.base.access,
    featureName: FEATURES.message_blast,
  },
  {
    icon: IconClockPaper,
    label: 'common:time&Mileage',
    path: routePaths.timesheetAndMileage.base.route,
  },
  {
    icon: IconCalendar,
    label: 'common:scheduling',
    path: routePaths.scheduling.base,
    featureName: FEATURES.scheduling,
  },
  {
    icon: IconPresentation,
    label: 'common:reports',
    path: routePaths.reports.base.route,
    access: routePaths.reports.base.access,
  },
  {
    icon: IconSleep,
    label: 'common:timeOff',
    path: routePaths.timeOff.base.route,
    featureName: FEATURES.time_off,
    isNew: true,
  },
  {
    icon: IconIntegration,
    label: 'common:integrations',
    path: routePaths.integrations.base.route,
    access: routePaths.integrations.base.access,
    featureName: FEATURES.integrations,
  },
  {
    icon: FaHospitalUser,
    label: 'common:evv',
    path: routePaths.evv.base.route,
    access: routePaths.evv.base.access,
    children: [
      {
        label: 'common:employees',
        path: routePaths.evv.employees,
      },
      {
        label: 'common:clients',
        path: routePaths.evv.clients,
      },
      {
        label: 'common:visits',
        path: routePaths.evv.visits,
      },
    ],
  },
];

export default sidebarData;
